export default __webpack_public_path__ + "static/covid-6be8dbcc178aefbbb9e0b202891a7ea6.gif";